const GOOGLE_TRANSLATE_REGEXES = [
  /closure_lm_/gm,
  /__closure_events_fn/gm,
  /translate_a/gm,
  /translate_http/gm,
];

const LIBRARY_ERROR_REGEXES = [/pipe/gm, /ne.current.focus/gm];

/* 
  If you need to ignore an error in a specific file put the error message and the file path in an object as shown below
  The file path must match the *first* path in the stack trace that sentry shows in order to function correctly.
  For more information: https://www.notion.so/schoolinkshome/Sentry-Triaging-2f5ccecb89cd4128864609687837aa42?pvs=4#7c9b7452343347889a0f09e77226ad56
*/
export const LIBRARY_ERROR_WITH_PATH_SPECIFIED_REGEXES = [
  {
    message: /SyntaxError/gm,
    file: /@fortawesome\/pro-solid-svg-icons\/index.js*/gm,
  },
  {
    message: /null is not an object \(evaluating 'd.current.offsetHeight'\)/gm,
    file: /@mui\/material\/node\/Tabs\/ScrollbarSize.js*/gm,
  },
  {
    message: /Unexpected EOF/gm,
    file: /@fortawesome\/pro-regular-svg-icons\/index.js*/gm,
  },
  {
    message: /Unexpected EOF/gm,
    file: /@fortawesome\/pro-solid-svg-icons\/index.js*/gm,
  },
  {
    message: /Unexpected end of script/gm,
    file: /@fortawesome\/pro-regular-svg-icons\/index.js*/gm,
  },
  {
    message: /Unexpected token '<'/gm,
    file: /@fortawesome*/gm,
  },
  {
    message: /null is not an object \(evaluating 'a[Zd]'\)/gm,
    file: /translate_a\/element.js*/gm,
  },
  {
    message: /Unexpected token '<', "<!DOCTYPE "... is not valid JSON/gm,
    file: /campusreel_api_carousel_bloomsburg.js*/gm,
  },
  {
    message: /Authentication credentials were not provided./gm,
    file: /src\/core\/axios\/handleError.js*/gm,
  },
];

export const NETWORK_ERROR_REGEXES = [
  /Failed to fetch/gm,
  /Network Error/gm,
  /Connection lost. Try reloading this page/gm,
  /Request failed/gm,
];

const ACCESSIBLE_ERROR_REGEXES = [/acsbapp.com/gm];

const SAFARI_LIMITATION_REGEXES = [
  /NotReadableError: The I\/O read operation failed/gm,
  /TypeError: Load failed/gm,
];

export const SENTRY_DENY_URLS = [
  /www\.walkscore\.com/i,
  /zamant\.ru/i,
  /maralo\.ru/i,
  /translate\.googleapis\.com/i,
  /cnd\.addpipe\.com/i,
];

export const IGNORED_ERRORS = [
  ...GOOGLE_TRANSLATE_REGEXES,
  ...LIBRARY_ERROR_REGEXES,
  ...SAFARI_LIMITATION_REGEXES,
  ...NETWORK_ERROR_REGEXES,
  ...ACCESSIBLE_ERROR_REGEXES,
];

export const PRODUCTION = 'prod';
export const LOCAL = 'local';

export const SENTRY_EXCLUDE_ENVIRONMENTS = [LOCAL];
